import Container from '@/components/aem-core/container';
import ExperienceFragment from '@/components/aem-core/experience-fragment';
import ResponsiveGrid from '@/components/aem-core/responsive-grid';
import XFPage from '@/components/aem-core/xf-page';
import type { MappingConfig } from '@multitenancy-spa/components-manager/esm/services/components-manager/typings';

const componentsToBeMapped: MappingConfig[] = [
	Container,
	ExperienceFragment,
	ResponsiveGrid,
	XFPage,
];

export default componentsToBeMapped;
